import React from 'react'
import './Cart.css'
const Cart = () => {
    return (
        <>
         <p>This is a cart page</p>   
        </>
    )
}

export default Cart
